import { Link } from "react-router-dom";
import { ArrowLeft, ArrowUpRight } from "lucide-react";
import Seo from "@/components/common/Seo";
import { KineticHeading } from "@/components/common/Reveal";

export default function NotFound() {
  return (
    <>
      <Seo title="Page Not Found" path="/404" />
      <section data-testid="not-found" className="relative flex min-h-screen items-center overflow-hidden bg-navy text-white grain-overlay">
        <div className="pointer-events-none absolute -right-40 top-0 h-[600px] w-[600px] rounded-full bg-royal/25 blur-[140px]" />
        <div className="relative mx-auto max-w-[1400px] px-6 md:px-12">
          <p className="font-body text-xs font-bold uppercase tracking-[0.3em] text-sky">Error 404</p>
          <h1 className="mt-6 font-heading text-[20vw] font-black leading-none tracking-tighter text-white/10 md:text-[13rem]">404</h1>
          <div className="mt-2 md:-mt-6">
            <h2 className="font-heading text-4xl font-light leading-tight tracking-tight md:text-6xl">
              <KineticHeading lines={["This page has", "moved on."]} lineClassName="font-light" />
            </h2>
            <p className="mt-6 max-w-md font-body text-lg text-slate-300">The page you&rsquo;re looking for doesn&rsquo;t exist, but the conversation can still begin.</p>
            <div className="mt-10 flex flex-wrap gap-4">
              <Link to="/" data-testid="notfound-home" className="group inline-flex items-center gap-2 rounded-full bg-royal px-8 py-4 font-body font-semibold text-white transition-colors hover:bg-sky hover:text-navy">
                <ArrowLeft className="h-5 w-5 transition-transform group-hover:-translate-x-1" /> Back to home
              </Link>
              <Link to="/book" data-testid="notfound-book" className="group inline-flex items-center gap-2 rounded-full border border-white/20 px-8 py-4 font-body font-medium text-white transition-colors hover:border-sky hover:text-sky">
                Book a session <ArrowUpRight className="h-4 w-4" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
